var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.361,
    height: 36.361,
    viewBox: "0 0 36.361 36.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(0.62 0.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_722",
    "data-name": "Path 722",
    transform: "translate(-0.62 -0.039)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.180419921875 35.86083984375 C 13.45780944824219 35.86083984375 9.01785945892334 34.02175903320312 5.678470134735107 30.68236923217773 C 2.339079856872559 27.34297943115234 0.4999999105930328 22.90303039550781 0.4999999105930328 18.180419921875 C 0.4999999105930328 13.45780944824219 2.339079856872559 9.01785945892334 5.678470134735107 5.678470134735107 C 9.01785945892334 2.339079856872559 13.45780944824219 0.4999999105930328 18.180419921875 0.4999999105930328 C 22.90303039550781 0.4999999105930328 27.34297943115234 2.339079856872559 30.68236923217773 5.678470134735107 C 34.02175903320312 9.01785945892334 35.86083984375 13.45780944824219 35.86083984375 18.180419921875 C 35.86083984375 22.90303039550781 34.02175903320312 27.34297943115234 30.68236923217773 30.68236923217773 C 27.34297943115234 34.02175903320312 22.90303039550781 35.86083984375 18.180419921875 35.86083984375 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.180419921875 1 C 13.59136009216309 1 9.276979446411133 2.787078857421875 6.03203010559082 6.03203010559082 C 2.787078857421875 9.276979446411133 1 13.59136009216309 1 18.180419921875 C 1 22.76947975158691 2.787078857421875 27.08386039733887 6.03203010559082 30.32880973815918 C 9.276979446411133 33.57376098632812 13.59136009216309 35.36083984375 18.180419921875 35.36083984375 C 22.76947975158691 35.36083984375 27.08386039733887 33.57376098632812 30.32880973815918 30.32880973815918 C 33.57376098632812 27.08386039733887 35.36083984375 22.76947975158691 35.36083984375 18.180419921875 C 35.36083984375 13.59136009216309 33.57376098632812 9.276979446411133 30.32880973815918 6.03203010559082 C 27.08386039733887 2.787078857421875 22.76947975158691 1 18.180419921875 1 M 18.180419921875 0 C 28.22118949890137 0 36.36083984375 8.139650344848633 36.36083984375 18.180419921875 C 36.36083984375 28.22118949890137 28.22118949890137 36.36083984375 18.180419921875 36.36083984375 C 8.139650344848633 36.36083984375 0 28.22118949890137 0 18.180419921875 C 0 8.139650344848633 8.139650344848633 0 18.180419921875 0 Z",
    stroke: "none",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_144_5",
    "data-name": "Component 144 \\u2013 5",
    transform: "translate(9.985 10.567)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 14.14,
    height: 14.14,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M7.369,2.781,2.225,8.065,0,14.461l6.4-2.086L11.541,7.23ZM13.9,2.364,12.1.556a1.686,1.686,0,0,0-2.5,0L8.065,2.086,12.236,6.4,13.9,4.728a1.762,1.762,0,0,0,.556-1.251A1.717,1.717,0,0,0,13.9,2.364Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.d2e824fc5acc0b81fccbf8f3374633b1.svg";
export { ForwardRef as ReactComponent };